import React, { useState } from "react";
import { CancelAdvanceBookingAssignLockers, openLocker } from "../api/api";
import { BUTTON_PRIMARY, BUTTON_WARNING } from "../assets/constants/Constants";
import CustomDialog from "./CustomDialog";
export default function UpcomingLockersComponent({ locker }) {
  /* ================= STATE ================= */
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const [selectedLocker, setSelectedLocker] = useState(null);
  const [loading, setLoading] = useState(false);

  /* ================= HELPERS ================= */
  const parseDateTime = (dateString) => {
    if (!dateString) return null;

    const [datePart, timePart] = dateString.split(" at ");
    return new Date(`${datePart} ${timePart}`);
  };

  const checkInTime = parseDateTime(locker.checkIn);
  const currentTime = new Date();
  const isActive = checkInTime && currentTime >= checkInTime;

  /* ================= OPEN LOCKER ================= */
  const handleLockerOpenOperation = async () => {
    try {
      console.log("locker open function called");

      const ref_id = locker.ref_id;
      const response = await openLocker(ref_id);

      console.log("lockerOpenResponse:", response);
    } catch (error) {
      console.error("Error opening locker:", error);
    }
  };

  /* CANCEL FLOW */

  // Step 1: Open dialog
  const HandleLockerCancel = (locker) => {
    setSelectedLocker(locker);
    setIsCancelDialogOpen(true);
  };

  // Step 2: Confirm cancel
  const confirmCancelBooking = async () => {
    try {
      setLoading(true);

      const requestdata = {
        transaction_id: selectedLocker.ref_id,
        cancellation_reason: "Cancelled by user",
      };

      const cancelResponse =
        await CancelAdvanceBookingAssignLockers(requestdata);

      console.log("Cancel Response:", cancelResponse);

      setIsCancelDialogOpen(false);
    } catch (error) {
      console.error("Cancel failed:", error);
    } finally {
      setLoading(false);
    }
  };

  /* ================= MODIFY ================= */
  const HandleLockerModifier = () => {
    console.log("calling locker modifier api...");
  };

  //  Move this OUTSIDE (above or separate file)
function CancelBookingContent({ locker }) {
  return (
    <div className="cancel-booking">
      <h3 className="cancel-booking__title">
        Cancel Booking?
      </h3>

  <p className="cancel-booking__text">
    Are you sure you want to cancel booking for{" "}
    <strong className="cancel-booking__locker">
      Locker #{locker?.lockerNumber}
    </strong>
    ?
    <br />
    This action cannot be undone.
  </p>
</div>
  );
}

  /* ================= UI ================= */
  return (
    <>
      <div className={`locker-card ${isActive ? "active" : "upcoming"}`}>
        
        {/* Header */}
        <div className="top">
          <div className="title">{locker.name}</div>

          <div
            className={`status ${
              isActive ? "active-status" : "upcoming-status"
            }`}
          >
            {isActive ? "Active" : "Upcoming"}
          </div>
        </div>

        {/* Locker Info */}
        <div className="sub-text">
          Locker #{locker.lockerNumber} - {locker.size} size
        </div>

        {/* Dates */}
        <div className="date-section">
          <div className="date-box">
            <span className="label">Check-in</span>
            <span className="value">{locker.checkIn}</span>
          </div>

          <div className="date-box">
            <span className="label">Check-out</span>
            <span className="value">{locker.checkOut}</span>
          </div>
        </div>

        <hr />

        {/* Footer */}
        <div className="footer">
          <div className="actions">
            {isActive ? (
              <div className="locker-access">
                <div className="access-title">🔒 Locker Access</div>
                <div className="access-sub">
                  Your locker reserved timing has started. Please open the locker.
                </div>

                <button
                  className="open-btn"
                  onClick={handleLockerOpenOperation}
                >
                  🔓 Open Locker
                </button>
              </div>
            ) : (
              <>
                <button
                  className="btn-outline"
                  onClick={HandleLockerModifier}
                >
                  Modify Booking
                </button>

                <button
                  className="btn-outline"
                  onClick={() => HandleLockerCancel(locker)}
                >
                  Cancel Booking
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* ================= CANCEL CONFIRMATION DIALOG ================= */}
      <CustomDialog
        dialogId="cancel-locker-dialog"
        dialogVisible={isCancelDialogOpen}
        onClose={() => setIsCancelDialogOpen(false)}
        handleCancel={() => setIsCancelDialogOpen(false)}
        handleAccept={confirmCancelBooking}
        buttonOneTitle="No"
        buttonTwoTitle={loading ? "Cancelling..." : "Yes, Cancel"}
        buttonProps={{
          buttonOne: { type: BUTTON_WARNING },
          buttonTwo: { type: BUTTON_PRIMARY, disabled: loading },
        }}
      >
        {() => <CancelBookingContent locker={selectedLocker} />}
</CustomDialog>
    </>
  );
}